<template>
  <div v-if="certInfo.length" class="wrapper">
    <div v-if="pngList && pngList.length" class="png-content">
      <img
        v-for="(item, index) in pngList"
        :key="index"
        class="pic"
        :src="imgFormatFilter(item, 600)"
        @error="imgLoadFail"
      />
    </div>
    <empty
      v-else
      :desc="'暂无报告'"
      :type="1"
      :img="'Empty'"
      class="empty-box"
    ></empty>
  </div>
</template>

<script>
import { imgLoadFail, imgFormatFilter } from '@/utils/imgTools'
import Empty from '@/common/layout/empty/index'
export default {
  components: {
    Empty
  },
  props: {
    activeIndex: {
      type: Number,
      default: 0
    },
    certInfo: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    pngList() {
      const obj = this.certInfo[this.activeIndex]
      return obj ? obj.cert || [] : []
    }
  },
  methods: {
    imgLoadFail,
    imgFormatFilter
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  display: flex;

  flex: 1;

  flex-direction: column;
}

.empty-content {
  display: flex;

  background: #fff;

  flex: 1;

  flex-direction: column;
  justify-content: center;
  align-items: center;

  & > .empty {
    width: 3rem;
  }
}

.png-content {
  display: flex;

  height: 0;

  background: #fff;

  flex: 1;

  flex-direction: column;

  .pic {
    width: 100%;

    background-repeat: no-repeat;
  }
}

.expand {
  transform: scale(2);
  transform-origin: 0 0;
}
</style>
